import React, { FC, Fragment, useEffect, useState } from "react";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import StartRating from "components/StartRating/StartRating";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import LikeSaveBtns from "components/LikeSaveBtns";
import SectionDateRange from "./SectionDateRange";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Amenities_demos, PHOTOS } from "./constant";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightIcon, Squares2X2Icon, PencilSquareIcon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import ButtonCircle from "shared/Button/ButtonCircle";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "./Layout";
import GuestsInput from "./GuestsInput";
import { connect, useDispatch } from "react-redux";
import { updateLoadingIsStatus } from "../../redux/reducers/spinnerReducer";
import api from '../../api';
import { setIsBlacklisted } from "../../redux/reducers/brandReducer";

import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import { Alert } from "@mui/material";
import ButtonThird from "shared/Button/ButtonThird";

const styles = {
  langflag: {
    width: '24px',
    margin: '0 4px'
  },
  sbTitle: {
    fontWeight: 'bold',
    marginRight: '12px'
  }
};

const BrandDetailContainer = ({ brand, user }) => {
  const dispatch = useDispatch();
  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);
  const [sbState, setSBState] = useState({
    open: false,
  });
  const { open } = sbState;
  const [pageLabel, setPageLabel] = useState('');

  const [isContactRequested, setisContactRequested] = useState(false);
  const [isBlacklisted, setIsBlacklistedState] = useState(false);
  const [isOwnBrand, setIsOwnBrand] = useState(false);
  const thisPathname = useLocation().pathname;
  const router = useNavigate();

  const handleOpenModalImageGallery = () => {
    router(`${thisPathname}?modal=PHOTO_TOUR_SCROLLABLE`);
  };

  const handleOpenModalVideoGallery = () => {
    router(`${thisPathname}?modal=VIDEO_FOCUS`);
    const params = new URLSearchParams(document.location.search);
    params.set("photoId", "0");
    router(`${thisPathname}?${params.toString()}`);
  };

  const handleContactRequest = () => {
    api.requestContact({
      requester_type: user?.company_type,
      requester_id: user?.company?.id,
      contact_type: brand?.company_type,
      contact_id: brand?.brandowner?.id,
    }, (res) => {
      openSuccessSnackbar({ vertical: 'bottom', horizontal: 'center' });
      setisContactRequested(true);
    });
  }

  const openSuccessSnackbar = (position) => {
    setSBState({ ...position, open: true });
  }

  const handleCloseSB = () => {
    setSBState({ ...sbState, open: false });
  }

  const fetchBlacklistStatus = (brandId) => {
    if (!user?.company?.id) {
      return;
    }
    api.getBlacklist(
      {
        owner: user.company_type,
        owner_id: user.company.id,
        preference: 'blacklist'
      },
      (res) => {
        if (res.status === 200) {
          const isBlack = res.data.some(item => {
            let item_id;

            if (user.company_type === "brandowners") {
              item_id = item.id;
              return item_id === brandId;
            } else {
              item_id = item.id;
              return item_id === brandId;
            }
          });
          setIsBlacklistedState(isBlack);
        }
      }
    );
  };

  useEffect(() => {
    setPageLabel(brand?.company_type == 'agencies' ? 'Agency' : 'Brand');

    if (brand?.id && user?.company_type && user?.company?.id) {
      fetchBlacklistStatus(brand.id);
    } else {
      setIsBlacklistedState(brand?.is_blacklisted || false);
    }

    setIsOwnBrand(user?.company?.id === brand?.brandowner?.id);
  }, [brand?.id, user?.company_type, user?.company?.id]);

  const handleAddToBlackList = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const newBlacklistStatus = !isBlacklisted;

    setIsBlacklistedState(newBlacklistStatus);

    api.toggleBlacklist(
      {
        owner: user.company_type,
        brand_id: user?.company_type == 'brandowners' ? user?.company?.id : brand?.id,
        agency_id: user?.company_type == 'brandowners' ? brand.id : user.company?.id,
        preference: 'blacklist'
      },
      (res) => {
        if (res.status === 200) {
          setIsBlacklistedState(res.data.is_blacklisted);

          dispatch(
            setIsBlacklisted({
              ...brand,
              is_blacklisted: res.data.is_blacklisted
            })
          );
          if (brand?.id) {
            fetchBlacklistStatus(brand.id);
          }
        } else {
          setIsBlacklistedState(isBlacklisted);
        }
      }
    );
  };

  const handleEdit = (type) => {
    router('/account?name=' + brand.shortname + '&page=' + type);
  }

  const renderEditButton = (type) => {
    return (
      <>
        {isOwnBrand && (
          <button
            type="button"
            className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Edit sales channel"
            onClick={() => handleEdit(type)}
          >
            <PencilSquareIcon className="w-5 h-5 text-gray-600 dark:text-gray-300" />
          </button>
        )}
      </>
    )
  }

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          <Badge name={pageLabel} />
          {user.id !== 0 && user.id !== null && (
            <LikeSaveBtns />
          )}
        </div>

        {/* 2 */}
        <div className="flex items-center mt-5">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold mr-2">
            {brand?.name}
          </h2>
          {renderEditButton('brand-basic-info')}
        </div>

        {/* 3 */}
        {/* <div className="flex items-center space-x-4">
          <StartRating />
          <span>·</span>
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1 mr-2"> {`${brand?.brandowner?.city}, ${brand?.brandowner?.country}`}</span>
            {renderEditButton('business-details')}
          </span>
        </div> */}

        {/* 4 */}
        <div className="flex items-center">
          <Avatar imgUrl={brand?.brandowner?.avatar ? api.getUploadUrl() + '/' + brand?.brandowner?.avatar?.url : null} hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400 mr-2">
            by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {brand?.brandowner?.name}
            </span>
          </span>
          {renderEditButton('business-details')}
        </div>

        <div className="flex items-center mt-5">
          <h2 className="text-2xl font-semibold mr-2">Brand Profile Information</h2>
          {renderEditButton('brand-basic-info')}
        </div>
        <div className="text-neutral-6000 dark:text-neutral-300 whitespace-pre-line">
          {brand?.description}
        </div>

      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <div>

          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>Current Sales Channel</h3>
            {renderEditButton('brand-sales-info')}
          </div>
          <p className="mt-3 ml-6 h-6">
            {brand?.sales_channels || ''}
          </p>


          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>Average Wholesale Price Range</h3>
            {renderEditButton('brand-sales-info')}
          </div>
          <p className="mt-3 ml-6 h-6">
            {brand?.price_range || ''}
          </p>


          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>Target Retail Type</h3>
            {renderEditButton('brand-sales-info')}
          </div>
          <p className="mt-3 ml-6 h-6">
            {brand?.retail_types || ''}
          </p>
        </div>

        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <h2 className="text-2xl font-semibold">Brand DNA {renderEditButton('brand-dna')}</h2>

          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>USP {'/'} What makes the brand special?</h3>

          </div>
          {brand?.brand_special
            ? <p className="mt-3 ml-6 whitespace-pre-line">{brand.brand_special}</p>
            : <p className="mt-3 ml-6 h-6">  </p>
          }


          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>Short Brand Story or Positioning Statement?</h3>
          </div>
          {brand?.short_brand_story
            ? <p className="mt-3 ml-6 whitespace-pre-line">{brand.short_brand_story}</p>
            : <p className="mt-3 ml-6 h-6">  </p>
          }

          <div className="flex items-center mt-5 ml-3">
            <h3 className='font-semibold mr-2'>Sustainability / Certifications</h3>
          </div>
          {brand?.sustainability
            ? <p className="mt-3 ml-6 whitespace-pre-line">{brand.sustainability}</p>
            : <p className="mt-3 ml-6 h-6">  </p>
          }

        </div>

        {brand?.agent_regions?.length > 0 || (brand?.agent_representation && brand?.agent_rep_regions?.length > 0) ? <>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
          <div>
            <h2 className="text-2xl font-semibold">Minimum Requirement for Agents {renderEditButton('brand-agent-requirements')}</h2>
            <div>
              {brand?.agent_regions?.length > 0 ? <>
                <div className="flex items-center mt-5 ml-3">
                  <h3 className='font-semibold mr-2'>Regions</h3>
                </div>
                <p className="mt-3 ml-6">{brand?.agent_regions?.map(item => item.region).join(", ")}</p>
              </> : <></>}

              {brand?.agent_commission_structure && <>
                <div className="flex items-center mt-5 ml-3">
                  <h3 className='font-semibold mr-2'>Commission structure or other incentives</h3>
                </div>
                <p className="mt-3 ml-6 whitespace-pre-line">{brand.agent_commission_structure}</p>
              </>}

              {brand?.agent_representation && brand?.agent_rep_regions?.length > 0 ? <>
                <div className="flex items-center mt-5 ml-3">
                  <h3 className='font-semibold mr-2'>New Representation Regions</h3>
                </div>
                <p className="mt-3 ml-6">{brand.agent_rep_regions?.map(item => item.region).join(", ")}</p>
              </> : <></>}
            </div>
          </div>
        </> : <></>}


        {user.id !== 0 && user.id !== null && (
          <Link to={'#'} onClick={handleAddToBlackList} className="py-1.5 px-3 flex justify-center rounded-lg bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-800 dark:text-white text-gray-800 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            <span className="hidden sm:block ml-2.5">{isBlacklisted ? 'Remove from blacklist' : 'Add to blacklist'}</span>
          </Link>
        )}
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        <div className="flex flex-col space-y-4">
          <div className="flex">
            <span style={styles.sbTitle} className="flex-1">Country</span>
            <span className="flex-1 mr-2">
              {/* <i className="las la-map-marker-alt"></i> */}
              <span className="ml-1">
                {brand?.country?.map(item => item).join(", ")}
              </span>
            </span>
            {renderEditButton('brand-basic-info')}
          </div>
          <div className="flex">
            <span style={styles.sbTitle} className="flex-1">Activity Regions</span>
            <span className="flex-1 mr-2">
              <span className="ml-1">
                {brand?.regions?.map(item => item.region).join(", ")}
              </span>
            </span>
            {renderEditButton('brand-sales-info')}
          </div>
          <div className="flex">
            <span style={styles.sbTitle} className="flex-1">Product Categories</span>
            <span className="flex-1 mr-2">
              <span className="ml-1">
                {brand?.market?.product_categories?.map(item => item.name).join(", ")}
              </span>
            </span>
            {renderEditButton('brand-sales-info')}
          </div>
          {brand?.website &&
            <div className="flex">
              <span style={styles.sbTitle} className="flex-1">Website</span>
              <span className="flex-1 mr-2">
                <span className="ml-1">
                  {brand?.website}
                </span>
              </span>
              {renderEditButton('brand-basic-info')}
            </div>
          }
          {brand?.instagram &&
            <div className="flex">
              <span style={styles.sbTitle} className="flex-1">Instagram</span>
              <span className="flex-1 mr-2">
                <span className="ml-1">
                  {brand?.instagram}
                </span>
              </span>
              {renderEditButton('brand-basic-info')}
            </div>
          }
          {brand?.linkedin &&
            <div className="flex">
              <span style={styles.sbTitle} className="flex-1">LinkedIn</span>
              <span className="flex-1 mr-2">
                <span className="ml-1">
                  {brand?.linkedin}
                </span>
              </span>
              {renderEditButton('brand-basic-info')}
            </div>
          }
        </div>

        {/* SUBMIT */}
        {user.id !== 0 && user.id !== null && (
          !isContactRequested ? (
            <ButtonPrimary href={"#"} onClick={handleContactRequest}>Request Contact</ButtonPrimary>
          ) : (
            <ButtonThird>Contact Requested</ButtonThird>
          )
        )}
      </div>
    );
  };

  return (
    <div className="nc-ListingStayDetailPage">
      {/*  HEADER */}
      {(brand?.showroom_video?.length || brand?.imageUrls?.length)
        ? <header className="rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
            <div
              className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer min-h-[400px]"
              onClick={
                brand?.showroom_video?.url
                  ? handleOpenModalVideoGallery
                  : handleOpenModalImageGallery
              }
            >
              {brand?.showroom_video?.url ? (
                <video
                  className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                  autoPlay muted loop
                  src={`${api.getUploadUrl()}/${brand.showroom_video.url}`}
                />
              ) : (
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                  src={brand?.imageUrls[0] ?? ''}
                  alt=""
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
              )}
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
            {brand?.imageUrls.filter((_, i) => i >= 1 && i < 5).map((item, index) => (
              <div
                key={index}
                className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 3 ? "hidden sm:block" : ""
                  }`}
              >
                <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                  <img
                    className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                    src={item || ""}
                    alt=""
                    sizes="400px"
                  />
                </div>

                {/* OVERLAY */}
                <div
                  className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                  onClick={handleOpenModalImageGallery}
                />
              </div>
            ))}

            <button
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
              onClick={handleOpenModalImageGallery}
            >
              <Squares2X2Icon className="w-5 h-5" />
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </button>
          </div>
        </header>
        : <></>}
      {/* MAIN */}
      <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className={`sticky ${isOwnBrand ? 'top-[170px]' : 'top-28'}`}>
            {renderSidebar()}
          </div>
        </div>
      </main>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSB}
        message="Contact Requested"
      >
        <Alert
          onClose={handleCloseSB}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Contact Request Sent!
        </Alert>
      </Snackbar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  isLoading: state.spinner.isLoading,
  brand: state.brand.brand,
});

export default connect(mapStateToProps, { updateLoadingIsStatus, setIsBlacklisted })(
  BrandDetailContainer
);